import React from 'react';

export const FakeLink = React.memo(
    React.forwardRef(({ to, ...rest }: { to: string; ref?: any }, ref: any) => (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a href={to || ''} {...rest} ref={rest.ref || ref} />
    )),
);
